// Use environment variable or fall back to localhost for development
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';
export const API_V1_PREFIX = '/v1';

export const API_URL = `${API_BASE_URL}${API_V1_PREFIX}`;